var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item,index){return _c('FaqItem',_vm._b({key:("faq-item-" + index),attrs:{"show":_vm.show === index},on:{"toggle":function($event){return _vm.faqToggle(index)}}},'FaqItem',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }